import { PatientAppInviteCard } from '../WellbeingPlan/PatientAppInviteCard';
import CaremapprModal from '../Modal/CaremapprModal/CaremapprModal';
import {
  MyPainHealthInviteModalBody,
  MyPainHealthInviteModalHeader,
} from './components/MyPainHealthInviteModal';
import { useInviteMyPainHealthPatient } from './hooks';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

const InviteMyPainHealthPatient = () => {
  const {
    loading,
    showModal,
    phone,
    setPhone,
    openInviteMyPainHealthModal,
    closeInviteMyPainHealthModal,
    onSendInviteMyPainHealthPatient,
    patientMyPainHealthUserStatus,
  } = useInviteMyPainHealthPatient();
  const { loading: patientProfileLoading } = useSelector(
    (state: RootState) => state.patientProfile,
  );
  const inviteSentNotOnboarding =
    'Patient invite sent, not completed onboarding';
  const completedOnboardingNotAppActive =
    'Patient completed onboarding, app not active';
  const consumerSignedUp = 'Patient app active';

  const computedStatus = {
    created: patientMyPainHealthUserStatus.created,
    onboarded: patientMyPainHealthUserStatus.onboarded,
    active: patientMyPainHealthUserStatus.active,
  };

  let title = 'Patient invite not sent';
  if (computedStatus.active) {
    title = consumerSignedUp;
  } else if (computedStatus.created) {
    title = computedStatus.onboarded
      ? completedOnboardingNotAppActive
      : inviteSentNotOnboarding;
  }

  if (patientProfileLoading) {
    return null;
  }

  return (
    <div className="col30">
      <div className="d-flex flex-wrap align-items-start gap-3 w-100">
        <div className="flex-grow-1">
          <PatientAppInviteCard
            activeTitle={title}
            description=""
            buttonName="Send SMS to patient"
            numberFieldTitle="Patient phone number"
            onInvitePatient={() => openInviteMyPainHealthModal()}
            loading={loading}
            showButton={!computedStatus.active && !computedStatus.onboarded}
            showTextField={false}
          />
        </div>
        <div className="txtInsightSettingsNote mt-4 flex-grow-1">
          <div>
            Patients are eligible to be invited to use the mypainhealth app if:
          </div>
          <ul className="mb-0 ps-3">
            <li>Aged 16-24 years at time of invitation</li>
            <li>
              Triaged to Category 2/3 (Category 1 patients are not eligible for
              the app)
            </li>
            <li>Primary index condition is chronic musculoskeletal pain</li>
          </ul>
        </div>
      </div>
      <CaremapprModal
        id="myPainHealthInviteModal"
        show={showModal}
        onHide={closeInviteMyPainHealthModal}
        size="lg"
        body={
          <MyPainHealthInviteModalBody
            onHide={closeInviteMyPainHealthModal}
            onSendInvite={onSendInviteMyPainHealthPatient}
            loading={loading}
            value={phone}
            onValueChange={setPhone}
          />
        }
        header={
          <MyPainHealthInviteModalHeader
            onHide={closeInviteMyPainHealthModal}
          />
        }
      />
    </div>
  );
};

export default InviteMyPainHealthPatient;
